@let balance = vacationBalance.balance(userId());
@let hasBalance = vacationBalance.hasBalance(userId());
@let isLoading = vacationBalance.isLoading(userId());

@defer (on hover) {
  <div
    nz-tooltip
    [nzTooltipTitle]="tooltip"
    nzTooltipColor="#fff"
    class="kpi-parent-container"
  >
    <ng-container *ngTemplateOutlet="vacationBalanceValue"></ng-container>
  </div>
} @placeholder {
  <div class="kpi-parent-container">
    <ng-container *ngTemplateOutlet="vacationBalanceValue"></ng-container>
  </div>
}

<ng-template #vacationBalanceValue>
  <span class="kpi-title text-truncate">
    {{ 'shift_timeline.kpi_setting.vacation_balance' | translate }}
  </span>
  <div class="kpi-value">
    @if (isLoading || !hasBalance) {
      <div class="skeleton-loading">
        <nz-skeleton
          [nzActive]="true"
          [nzParagraph]="{ rows: 1 }"
          [nzTitle]="false"
        ></nz-skeleton>
      </div>
    } @else if (balance === null) {
      <span class="kpi-text">
        {{ 'general.n/a' | translate }}
      </span>
    } @else {
      <span class="kpi-text">
        {{
          'shift_timeline.kpi_setting.vacation_balance.days'
            | translate: { count: balance | numberFormatter }
        }}
      </span>
    }
  </div>
</ng-template>

<ng-template #tooltip>
  <span class="fw-normal">
    {{ 'shift_timeline.kpi_setting.vacation_balance' | translate }}
  </span>
  <span class="d-block"> {{ yearStart() }} - {{ yearEnd() }} </span>
</ng-template>
